import 'jquery';
export class Sidebar {
    enable() {
        this.showRightSidebarOpenIcon();
    }

    disable() {
        this.hideRightSidebarOpenIcon();
    }

    hide() {
        this.hideRightSidebar();
    }

    show() {
        this.showRightSidebar();
    }

    toggle() {
        this.toggleRightSidebarVisibility();
    }

    /**
    * hideRightSidebar hides the right sidebar
    */
    hideRightSidebar() {
        $('.unify-right-sidebar').addClass('hidden');
        // remove padding used for menu
        $($('.section-main-content')[0]).removeClass('unify-right-sidebar-padding');
    }

    /**
    * showRightSidebar shows the right sidebar
    */
    showRightSidebar() {
        // show it
        $('.unify-right-sidebar').removeClass('hidden');

        // add padding to main content
        $($('.section-main-content')[0]).addClass('unify-right-sidebar-padding');
    }

    /**
    * showRightSidebarOpenIcon shows the right sidebar open icon
    */
    showRightSidebarOpenIcon() {
        // remove class
        $('.unify-right-sidebar-icon-open').removeClass('unify-hidden');
    }

    /**
    * sidebarRightWrapperOpenIconHide shows the right sidebar open icon
    */
    hideRightSidebarOpenIcon() {
        // remove class
        $('.unify-right-sidebar-icon-open').addClass('unify-hidden');
    }

    /**
    * toggleRightSidebarVisibility toggle visibility of the sidebar
    */
    toggleRightSidebarVisibility() {
        var that = this;
        // default sideBar has class hidden, when removed it will be shown, but you also have to add padding to the main content
        var sidebar = $('.unify-right-sidebar');
        if ($(sidebar).is(':visible')) {
            // sidebar was visible, hide it
            that.hideRightSidebar();
        }
        else {
            // sidebar was hidden, show it
            that.showRightSidebar();
        }
    }
}
